import { Dropdown } from "primereact/dropdown";
import { useTaskAnalysis } from "../../Hooks/Features/ProjectGlance/useTaskAnalysis";
import CommonGrid from "../CommonCompo/CommonGrid/CommonGrid";
import { SkeletonDataTable } from "../Loader/Loader";
import TaskDetailsPopup from "./TaskDetailsPopup";

const TaskBreakdown = ({ projectId }) => {

    const tab = "task_breakdown";
    const { taskColumns, taskRowData, opts, filterValues, setFilterValues, loader, detailsPopup, setDetailsPopup } = useTaskAnalysis({ projectId, tab });

    return (
        <div className="h-100 w100">
            <div className="d-flex align-items-center justify-content-between">
                <div className="fs-6 fw-semibold">Task Breakdown by Status</div>
                <div className="w15">
                    <Dropdown className="input-dd" placeholder="Group By" options={opts?.task_breakdown_group} optionLabel="task_breakdown_name" value={filterValues?.task_breakdown_group} onChange={(e) => setFilterValues((prev) => ({ ...prev, task_breakdown_group: e.target.value }))} />
                </div>
            </div>
            <div className="mt-2" style={{ height: "85%", overflowX: "auto", width: "100%" }}>
                {loader ? <SkeletonDataTable numSkeletons={9} />
                    : <div className="w100">
                        <CommonGrid columns={taskColumns} data={taskRowData?.data} bottomRowData={taskRowData?.bottom_row_data} headerHeight={60}/>
                    </div>
                }
            </div>

            {detailsPopup?.visible && <TaskDetailsPopup projectId={projectId} detailsPopup={detailsPopup} onClose={() => setDetailsPopup((prev) => ({ ...prev, visible: false, data: {} }))} header={detailsPopup?.data?.header} />}
        </div>
    )
}

export default TaskBreakdown